import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters(['account', 'company', 'globalLoading', 'initialized', 'countries', 'languages', 'appLanguage']),
  },
  methods: {
    ...mapActions(['setLoading']),
    async errorSnack (error) {
      let message = error.response ? error.response.data.error : error.message;
      if (message === 'TOKEN_EXPIRED' || message === 'Access Denied') {
        return this.$store.dispatch('logout');
      }
      this.$snack.danger({
        text: message,
        button: 'OK'
      });
    },
    successSnack (message) {
      this.$snack.success({
        text: message,
        button: 'OK'
      });
    },

    /**
     * Get Gender label based on the char M/F/U
     * @param char
     * @returns {*|*|void}
     */
    getGenderLabel(char) {
      switch (char) {
        case 'M': return this.$ml.get('male');
        case 'F': return this.$ml.get('female');
        case 'U': return this.$ml.get('both');
        default: return this.$ml.get('unknown');
      }
    },


    /**
     * Get country id by name
     * @param countryName
     * @returns Country from Vuex
     */
    getCountryIdByName(countryName) {
      const country = this.countries.filter(country => country.name.indexOf(countryName) !== -1)[0];
      if (country) return country.id;
      else return undefined;
    },
    /**
     * Get country model by id
     * @param countryId
     * @returns Country from Vuex
     */
    getCountryById(countryId) {
      return this.countries.filter(country => country.id === countryId)[0];
    },
    /**
     * Get language model by id
     * @param languageId
     * @returns Language from Vuex
     */
    getLanguageById(languageId) {
      return this.languages.filter(language => language.id === languageId)[0];
    },

    /**
     * Return Link to google maps from company object
     * @param company
     * @returns {string} - Google Maps Link
     */
    companyGoogleMaps(company){
      let link = `http://www.google.com/maps/place/`;
      if (!!company.links.place_id) link += `?q=place_id:${company.links.place_id}`;
      else if (!!company.latitude && !!company.longitude) link += `${company.latitude},${company.longitude}`;
      return link;
    },
    /**
     * Return Flag from provided Language name
     * @param language English/German/Serbian
     * @returns {string} - Google Maps Link
     */
    languageFlag(language){
      let shortcut;
      switch (language) {
        case 'English' : { shortcut = 'GB'; break; }
        case 'German' : { shortcut = 'DE'; break; }
        case 'Serbian' : { shortcut = 'RS'; break; }
      }
      return 'https://cdn.nimmshop.at/flags/' + shortcut + '.png';
    },

    /** Download div by id as png image */
    downloadImageDivById(divId, filename = 'download.png') {
      const domtoimage = require('dom-to-image');
      const filesaver = require('file-saver');

      let scale = 5;
      let domNode = document.getElementById(divId);
      let options = {
        width: domNode.clientWidth * scale,
        height: domNode.clientHeight * scale,
        style: {
          transform: 'scale(' + scale + ')',
          transformOrigin: 'top left'
        },
      };
      domtoimage.toBlob(domNode, options)
        .then((blob) => {
          filesaver.saveAs(blob, filename);
        });
    },
    /** Copy string to clipboard */
    copy (str = '') {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.successSnack(this.$ml.get('copied'))
    },

    /** Prompt to confirm with sweet alert */
    prompt(callback,
           title=this.$ml.get('are_you_sure'),
           text=this.$ml.get('cannot_undo'),
           type='warning',
           confirmButtonText=this.$ml.get('yes_proceed'),
           cancelButtonText=this.$ml.get('no_cancel')) {
      this.$swal({ title, text, type, confirmButtonText, cancelButtonText,
        showCancelButton: true,
      }).then(async function (result) {
        if (result.value) {
          callback()
        }
      })
    },

    /** Function which checks if provided string is valid JSON  */
    isJson (string) {
      if (string === 'null' || string === null) return false;
      try {
        JSON.parse(string);
      } catch (e) {
        return false;
      }
      return true;
    },
    /** Function which checks if provided object is empty  */
    isEmpty(obj) {
      for (let prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          return false;
        }
      }
      return JSON.stringify(obj) === JSON.stringify({});
    },
    /** Function which truncates string after provided length and adds ... */
    truncate(string, position) {
      if (string && string.length > position)
        return string.substring(0, position) + '...';
      else return string;
    },
    numberSuffixFormatter(number) {
      if (number > 999 && number <= 999999)
        return (number / 1000).toFixed(1) + 'K';
      else if (number > 999999) return (number / 1000000).toFixed(1) + 'M';
      return number;
    },
    firstLetterUppercase(string, lowercaseFirst = false) {
      if (lowercaseFirst) string = string.toLowerCase();
      return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
    },
    isNumber(evt, input) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      // Numbers and dot only
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        // If "."(dot) already exists - prevent
        // Only 2 decimals after the comma
        if (
          (charCode === 46 && input.indexOf('.') !== -1) ||
          (input.indexOf('.') !== -1 && input.split('.')[1].length >= 2)
        )
          evt.preventDefault();
        else return true;
      }
    },
    randomUntil(number) {
      return Math.floor(Math.random() * number) + 10;
    },
    getHTMLInvoice (invoice) {
      return  `<html>
  <head>
      <meta charset="utf-8">
      <title>NimmNet ${this.$ml.get('invoice')} #${invoice.id}</title>

      <style>
      .invoice-box {
          max-width: 800px;
          margin: auto;
          padding: 30px;
          border: 1px solid #eee;
          box-shadow: 0 0 10px rgba(0, 0, 0, .15);
          font-size: 16px;
          line-height: 24px;
          font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
          color: #555;
      }

      .invoice-box table {
          width: 100%;
          line-height: inherit;
          text-align: left;
      }

      .invoice-box table td {
          padding: 5px;
          vertical-align: top;
      }

      .invoice-box table tr td:nth-child(2) {
          text-align: right;
      }

      .invoice-box table tr.top table td {
          padding-bottom: 20px;
      }

      .invoice-box table tr.top table td.title {
          font-size: 45px;
          line-height: 45px;
          color: #333;
      }

      .invoice-box table tr.information table td {
          padding-bottom: 40px;
      }

      .invoice-box table tr.heading td {
          background: #eee;
          border-bottom: 1px solid #ddd;
          font-weight: bold;
      }

      .invoice-box table tr.details td {
          padding-bottom: 20px;
      }

      .invoice-box table tr.item td{
          border-bottom: 1px solid #eee;
      }

      .invoice-box table tr.item.last td {
          border-bottom: none;
      }

      .invoice-box table tr.total td:nth-child(2) {
          border-top: 2px solid #eee;
          font-weight: bold;
      }

      @media only screen and (max-width: 600px) {
          .invoice-box table tr.top table td {
              width: 100%;
              display: block;
              text-align: center;
          }

          .invoice-box table tr.information table td {
              width: 100%;
              display: block;
              text-align: center;
          }
      }

      /** RTL **/
      .rtl {
          direction: rtl;
          font-family: Tahoma, 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
      }

      .rtl table {
          text-align: right;
      }

      .rtl table tr td:nth-child(2) {
          text-align: left;
      }
      </style>
  </head>

  <body>
      <div class="invoice-box">
          <table cellpadding="0" cellspacing="0">
              <tr class="top">
                  <td colspan="2">
                      <table>
                          <tr>
                              <td class="title">
                                  <img src="https://cdn.nimmshop.at/nimmnet/logo-dark.png" style="width:100%; max-width:300px;">
                              </td>
                              <td>
                                  ${this.$ml.get('invoice')}-ID: #${invoice.id}<br>
                                  ${this.$ml.get('created')}: ${this.$moment(invoice.time).format('DD.MM.YYYY')}<br>
                              </td>
                          </tr>
                      </table>
                  </td>
              </tr>

              <tr class="information">
                  <td colspan="2">
                      <table>
                          <tr>
                              <td>
                                  NimmNet e.U.<br>
                                  IBAN: AT43 2011 1840 5104 5500<br>
                                  BIC: GIBAATWWXXX<br>
                                  @: info@nimmshop.at<br>
                                  T: +436764900674<br>
                                  FN 506585d<br>
                                  ATU 74243179<br>
                                  Stuwerstrasse 20/18<br>
                                  1020, Vienna
                              </td>
                              <td>
                                  ${this.$ml.get('company')}-ID: #${this.company.id}<br>
                                   ${this.company.billing.legal_name}<br>
                                   ${this.company.billing.address}<br>
                                   ${this.company.billing.email}
                              </td>
                          </tr>
                      </table>
                  </td>
              </tr>

              <tr class="heading">
                  <td>
                      ${this.$ml.get('payment_method')}
                  </td>
                   <td>
                      #
                  </td>
              </tr>

              <tr class="details">
                  <td>
                      ${invoice.payment}
                  </td>
                  <td>
                      ${invoice.number || ''}
                  </td>
              </tr>

              <tr class="heading">
                  <td>
                      ${this.$ml.get('product')}
                  </td>
                  <td></td>
              </tr>
              <tr class="item last">
                  <td>
                      ${invoice.description}
                  </td>
                  <td></td>
              </tr>

              <tr class="total">
                  <td> </td>
                  <td>
                     ${this.$ml.get('net')}: ${invoice.net.toFixed(2)} €
                  </td>
              </tr>
              <tr class="total">
                <td> </td>
                  <td>
                     ${this.$ml.get('vat')} 20%: ${(invoice.net / 5).toFixed(2)} €
                  </td>
              </tr>
              <tr class="total">
                <td> </td>
                  <td>
                     ${this.$ml.get('total')}: ${invoice.gross.toFixed(2)} €
                  </td>
              </tr>
          </table>
      </div>
  </body>
  </html>`;
    }
  }
};
